import { gql } from '@apollo/client';

export const DUPLICATE_FRAMEWORKRESULT = gql`
  mutation duplicateFrameworkResult($id: ID!) {
    data: duplicateFrameworkResult(id: $id) {
      pairs {
        oldId
        newId
      }
    }
  }
`;
